import { useContext } from "react";

import { AuthenticationContext } from "@/shared/contexts/AuthenticationContext";

export function useAuthentication() {
  const ctx = useContext(AuthenticationContext);

  if (!ctx) {
    throw new Error("useAuthentication must be used within an AuthenticationProvider");
  }

  return ctx;
}
